import { LazyLoad } from 'app/utils';

export const CouponFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.CouponFormPage,
);
